import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "./../../modules/material.module";
import { PatientSearchComponent } from "./patient-search.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [PatientSearchComponent],
  imports: [CommonModule, MaterialModule,TranslateModule],
  exports: [PatientSearchComponent]
})
export class PatientSearchModule {}
